import { Component } from '@angular/core';

@Component({
  selector: 'footer-ui',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
})
export class FooterComponent {}
